import { normalizeWhitespace, toString } from './string';
import { Decimal } from 'decimal.js';

export const computeFractionDivide = (value: string): number => {
  value = toString(value);

  if (!value.includes('/')) {
    const number = parseFloat(value);
    if (isNaN(number)) {
      throw new Error(`${value} is not a valid number`);
    }
  }

  const parts = value
    .split('/', 2)
    .map(normalizeWhitespace)
    .map((str) => parseInt(str, 10));
  return parts[0] / parts[1];
};

/**
 * @return float|int|null
 * @param value
 */
export const computeFraction = (
  value?: string | number | null
): number | undefined => {
  if (typeof value === 'number') {
    return value;
  }

  if (value === '' || value === null || value === undefined) {
    return;
  }

  value = normalizeWhitespace(value)
    .toLowerCase()
    .replace(/inches|inch|"/g, '')
    .trim();

  if (!value.includes('/')) {
    const number = parseFloat(value);
    if (isNaN(number)) {
      throw new Error(`${value} is not a valid number or fraction`);
    }
    return number;
  }

  value = value.replace(/ \/ /g, '/');
  if (value.includes(' ')) {
    const parts = value.split(' ', 2).map((part) => {
      if (!part.includes('/')) {
        return parseFloat(part);
      }
      return computeFractionDivide(part);
    });

    return parts[0] + parts[1];
  }

  return computeFractionDivide(value);
};

export const formatDecimal = (
  value: null | undefined | string | number,
  fractionDigits = 1
): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  if (typeof value === 'string') {
    value = parseFloat(value);
    if (isNaN(value)) {
      return '';
    }
  }
  return value.toFixed(fractionDigits);
};

export const toDecimal = (input: any): Decimal | undefined => {
  try {
    const decimal = Decimal(input);
    if (decimal.isNaN() || !decimal.isFinite()) {
      return undefined;
    }
    return decimal;
  } catch (e) {}
  return undefined;
};

export const toNumber = (input: any): number | undefined => {
  if (typeof input === 'number') {
    if (isNaN(input)) {
      return undefined;
    }
    return input;
  }
  if (typeof input === 'string') {
    if (input === '') {
      return undefined;
    }
    const number = parseFloat(input);
    if (isNaN(number)) {
      return undefined;
    }
    return number;
  }
  return undefined;
};

const numberCheck = /^-?\d*\.?\d*$/;
export const maybeNumber = (value?: number | string | null) => {
  if (typeof value !== 'string' || value.length === 0) {
    return value;
  }

  const isNumber =
    numberCheck.test(value) &&
    (value === '0' || value.indexOf('0') !== 0 || value.indexOf('.') !== -1);
  if (isNumber) {
    return parseFloat(value);
  }
  return value;
};
